import * as React from "react";
var ListContext = React.createContext({
  size: null,
  type: null
});
export default ListContext;